import React from 'react'

function footer() {
  return (
    <footer className='bg-light'>
     <div className='container'>
        <div className='d-flex justify-content-center p-4'>© 2002 - 2024 3e. All rights reserved.</div>
     </div>
    </footer>
  )
}

export default footer
